<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva Evaluación" v-model="show" :footer-hide="true" :scrollable="true">
        <Alert type="warning">
            Antes de continuar, confirma que todos los programas activos del ILSB tienen su lista de miembros actualizada.
        </Alert>
        <Form style="width: 100%" ref="planForm" :model="evaluation" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input v-model="evaluation.name" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Siguiente</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                evaluation: {
                    name: new Date().getFullYear(),
                },
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido' }
                    ]
                },
                programs: [],
                user_groups: [],
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        window.EventBus.$emit('evaluations--create-popup--usrs', this.evaluation.name)
                        this.show = false
                    }
                })
            },
            clear(){
                this.evaluation =  {
                    name: "",
                }
            }
        },
        mounted(){
            window.EventBus.$on('evaluations--create-popup', () => {
                this.show = true
            })
        }
    }
</script>
